import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  getUserInfo: {
    url: '/user/detail',
    method: 'get'
  },
  setUserInfo: {
    url: '/user/update',
    method: 'post'
  },
  uploadUserIcon: {
    url: '/user/uploadUserIcon',
    method: 'post'
  },
  // 获取手机验证码
  getUserVerifyCode: {
    url: '/user/getUserVerifyCode',
    method: 'post'
  },
  // 校验手机验证码
  checkUserVerifyCode: {
    url: '/user/checkUserVerifyCode',
    method: 'post'
  },
  // 获取省市区字典
  getGBCode: {
    url: '/user/getGBCode',
    method: 'get'
  }
};
export default withHttp(apis, baseURL);